import {connect} from "react-redux";
import {NotificationComponent} from "./NotificationComponent";

const mapStateToProps = (state) => {
    const {user, changePasswordForm, profile} = state;
    return {
        user,
        changePasswordForm,
        profile
    };
};

export const Notifications = connect(mapStateToProps, {

})(NotificationComponent);
